export default __webpack_public_path__ + "static/media/newLoadingGif.e3abe667.gif";